// extracted by mini-css-extract-plugin
export var black = "_n-6";
export var brand = "_n-1";
export var ddefault = "_n-0";
export var error = "_n-3";
export var gray = "_n-2";
export var highContrast = "_n-8";
export var outline = "_n-7";
export var success = "_n-5";
export var warning = "_n-4";